export enum GoogleIntegrationSetupStatus {
  None = 0,
  InProgress = 1,
  Completed = 2,
  Requested = 3
}
